// Where the backend lives. Empty (the default) = same origin: in development
// Vite proxies /api and /ws to the backend. In production the app is on
// Cloudflare Pages and the backend on its own name, so the build sets
// VITE_API_BASE=https://api.signal.vuthy.dev (scripts/build-frontend.sh).

export const API_BASE = (import.meta.env.VITE_API_BASE ?? "").replace(/\/+$/, "");

/** "/api/desk" → "https://api.signal.vuthy.dev/api/desk" (or unchanged when same-origin). */
export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

/** The WebSocket address for a backend path ("/ws/prices"). */
export function wsUrl(path: string): string {
  if (API_BASE) return `${API_BASE.replace(/^http/, "ws")}${path}`;
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${protocol}//${window.location.host}${path}`;
}

/**
 * The backend URL for a fetch target, or null when it isn't an API call: a
 * relative "/api/…" (rewritten onto API_BASE), or an absolute URL already on
 * the backend's origin.
 */
export function backendUrlOf(input: RequestInfo | URL): URL | null {
  const raw = typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
  const url = new URL(raw, window.location.href);
  if (!url.pathname.startsWith("/api/")) return null;
  if (url.origin === window.location.origin) return API_BASE ? new URL(`${API_BASE}${url.pathname}${url.search}`) : url;
  if (API_BASE && url.origin === new URL(API_BASE).origin) return url;
  return null;
}
